import { render, staticRenderFns } from "./about_aerta.vue?vue&type=template&id=33a007c1&scoped=true"
import script from "./about_aerta.vue?vue&type=script&lang=js"
export * from "./about_aerta.vue?vue&type=script&lang=js"
import style0 from "./about_aerta.vue?vue&type=style&index=0&id=33a007c1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a007c1",
  null
  
)

export default component.exports